<script lang="ts" setup>
import { computed, inject, onMounted } from "vue";
import { useDisableRules } from "@/composables/reactive/useDisableRules";
import TooltipButton from "@/components/buttons/TooltipButton.vue";
import type { Order } from "@/api/orders/dto/order.dto";

const { createSaveOrderDisableRules } = useDisableRules();

const props = withDefaults(
  defineProps<{
    order?: Order | null;
    loading?: boolean;
  }>(),
  {
    loading: false,
    order: null,
  },
);

const emit = defineEmits(["cancel", "submit"]);

const formSymbol = inject("formSymbol");

const saveDisableRules = computed(() => {
  if (props.order) {
    return createSaveOrderDisableRules(props.order);
  }

  return [];
});

onMounted(() => {
  if (!formSymbol) {
    throw new Error("FormActions must be a child of OmniForm");
  }
});

const submit = () => {
  emit("submit");
};

const cancel = () => {
  emit("cancel");
};
</script>

<template>
  <div class="d-flex justify-end pa-5 bg-white actions">
    <v-btn
      id="cancel-btn"
      :loading="loading"
      class="mr-3 text-primary text-uppercase font-weight-600"
      height="36"
      variant="flat"
      @click="cancel"
    >
      Cancel
    </v-btn>

    <tooltip-button :rules="saveDisableRules">
      <template #default="{ disabled }">
        <v-btn
          id="save-btn"
          :disabled="disabled"
          :loading="loading"
          class="pr-6 pl-6 font-weight-600 text-uppercase"
          color="primary"
          height="36"
          variant="flat"
          @click="submit"
        >
          Save
        </v-btn>
      </template>
    </tooltip-button>
  </div>
</template>

<style lang="scss" scoped>
.actions {
  position: fixed;
  width: 100%;
  right: 0;
  bottom: 0;
  box-shadow: 0 -8px 20px -7px rgba(0, 0, 0, 0.1);
  z-index: 99;
}
</style>
